import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { fetchData, formatNumber, getTranslatedValue, toasterrormsg } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import { KTIcon } from '../../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import DataTable from '../../../components/AppDataTable'
import Loader from '../../component/Loader'
import { Modal } from 'react-bootstrap'
import { Tr } from '../../../../_metronic/i18n/Tr'
import moment from 'moment'
import Select from 'react-select'
import { useLang } from '../../../../_metronic/i18n/Metronici18n'

const ViewSpaceCancelledBooking: FC = () => {

  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId');
  useEffect(() => {
    if (categoryId != '4') {
      navigate('../dashboard/');
    }
  }, [categoryId])

  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  const [cancellationBookingList, setCancellationBookingList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [cancellationPolicyInfo, setCancellationPolicyInfo] = useState("")
  const [showInfo, setShowInfo] = useState(false);
  const handleCloseInfo = () => setShowInfo(false);
  const handleShowInfo = () => setShowInfo(true);
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalRecords, setTotalRecords] = useState('') as any
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const yearTypeList = [
    { label: t('All'), value: 'All' },
    { label: t('Yearly'), value: 'Yearly' }
  ]
  const [yearTypeSelectedOptions, setYearTypeSelectedOption] = useState({}) as any;
  useEffect(() => {
    setYearTypeSelectedOption({
      value: 'All',
      label: t('All') // Re-apply current translation
    });
  }, [t('All')]);
  const [yearList, setYearList] = useState([])
  const [yearSelectedOptions, setYearSelectedOption] = useState() as any;
  const [monthList] = useState([
    { value: '0', label: 'ALL' },
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ]) as any
  const [selectedMonth, setSelectedMonth] = useState("") as any

  // generate list of years from vendor created years to current tear
  const generateYearList = (startYear: any) => {
    const currentYear = moment().year();
    const years = [] as any;

    for (let year = currentYear; year >= startYear; year--) {
      years.push({ label: year.toString(), value: year.toString() });
    }

    setYearList(years);
  };
  const getVendorId = (): string => {
    const raw = sessionStorage.getItem('vendor')
    const v = raw ? JSON.parse(raw) : null
    return v?.vendorId ? String(v.vendorId) : ''
  }

  // view profile api call
  const viewprofile = async () => {
    const _vendorId = getVendorId()
    if (!_vendorId) return
    var param: any = {
      vendorId: _vendorId,
    }
    var response: any = await fetchData("public/viewProfile", param)
    if (response.status == "200") {
      var data = response.data[0]
      generateYearList(moment(data).format('YYYY'))
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    viewprofile()
  }, [])

  //  booking list api call
  const cancellationBookingListApiCall = async () => {
    setIsLoading(true)
    var param: any = {
      vendorId: String(vendorId),
      categoryId: "4",
      limit: limit,
      offset: offset,
      sortOrder: sortDirection,
      field: sortColumn,
      searchText: searchTerm
    }
    if (yearSelectedOptions) {
      param['year'] = yearSelectedOptions.value
    }
    if (selectedMonth) {
      param['month'] = selectedMonth
    }
    var res = await fetchData('public/cancellationRecords', param)

    if (res.status == '200') {
      setIsLoading(false)
      var data = res.data
      const filteredData = data.data.filter((row: any) => row.cancellationCharge !== 'LastRecord');
      const totalRow = data.data.find((row: any) => row.cancellationCharge === 'LastRecord');

      const tableData = totalRow ? [...filteredData, totalRow] : filteredData;
      setCancellationBookingList(tableData)
      setTotalRecords(data.totalRecord)
    } else {
      toasterrormsg(res.message)
    }
  }

  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit)

    if (newPage === 1) {
      setOffset(0)
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit)
    } else {
      setOffset((newPage - 1) * limit)
    }
  }

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setLimit(newRowsPerPage)
  }
  // search Data
  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    // if (text == '' || text == null || text == undefined) {
    //   setCancellationBookingList(orgCancellationBookingList)
    // } else {
    //   var tmp: any = orgCancellationBookingList.filter((item: any) => {
    //     return (
    //       (item.bookingCode != null &&
    //         item.bookingCode != '' &&
    //         item.bookingCode.toLowerCase().includes(text.toLowerCase())) ||
    //       (item.guestName != null &&
    //         item.guestName != '' &&
    //         item.guestName.toLowerCase().includes(text.toLowerCase())) ||
    //       (item.dayBeforeCheckIn != null &&
    //         item.dayBeforeCheckIn != '' &&
    //         item.dayBeforeCheckIn.toLowerCase().includes(text.toLowerCase())) ||
    //       (item.en_actiontypeName != null &&
    //         item.en_actiontypeName != '' &&
    //         item.en_actiontypeName.toLowerCase().includes(text.toLowerCase())) ||
    //       (item.ru_actiontypeName != null &&
    //         item.ru_actiontypeName != '' &&
    //         item.ru_actiontypeName.toLowerCase().includes(text.toLowerCase())) ||
    //       (item.uz_actiontypeName != null &&
    //         item.uz_actiontypeName != '' &&
    //         item.uz_actiontypeName.toLowerCase().includes(text.toLowerCase()))
    //     )
    //   })

    //   setCancellationBookingList(tmp)
    // }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {

      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex flex-wrap'>
          <Select
            className='m-1 w-150px'
            options={yearTypeList}
            value={yearTypeSelectedOptions}
            placeholder={t('Select')}
            onChange={(e: any) => { setYearTypeSelectedOption(e); setYearSelectedOption() }}
          />
          {
            yearTypeSelectedOptions && yearTypeSelectedOptions.value == 'Yearly' && (
              <Select
                className='m-1 w-150px'
                options={yearList}
                value={yearSelectedOptions}
                placeholder={t('Select Year')}
                onChange={(e: any) => setYearSelectedOption(e)}
              />
            )
          }
          {
            yearSelectedOptions && (
              <Select
                className='m-1 w-150px'
                name='month'
                id='month'
                placeholder={t('Select Month')}
                isSearchable={true}
                isClearable={true}
                options={monthList}
                value={monthList.find(
                  (option: any) => option.value == selectedMonth
                ) || ""}
                onChange={(e: any) => { setSelectedMonth(e ? e.value : ''); }}
              />
            )
          }
        </div>
      </div>
    )
  }

  const handleSort = (column: any, sortDirection: 'asc' | 'desc') => {
    setSortColumn(column.sortField)
    setSortDirection(sortDirection)
  }
  // Define your DataTable columns
  const column: any = useMemo(
    () => [
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('#')}</label>),
        selector: (row: any, index: any) => row.cancellationCharge != 'LastRecord' ? index + 1 : '', // Add 1 to start from 1 instead of 0
        width: '50px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Booking ID')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <label className='fs-6 fw-bold cursor-pointer'>
              {
                row.bookingCode ? (
                  <Link
                    to='../viewspacebookingdetails/'
                    state={{ bookingId: row.bookingId }}
                    className='text-primary text-decoration-underline fw-bold text-hover-primary mx-2'
                  >
                    {row.bookingCode ? '#' + row.bookingCode : ''}
                  </Link>
                ) : (
                  <div className='ms-2'>{t('Total')}</div>
                )
              }
            </label>
          </div>
        ),
        sortable: true,
        sortField: 'bookingCode',
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Booking Status')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            {row.cancellationCharge != 'LastRecord' ? (
              <>
                <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Cancelled')}</span> <br />
              </>
            ) : (
              ''
            )}
            <div className='text-center mt-2'>
              <span className='fw-bold fs-6'>

                {row.cancellationCharge == 'LastRecord'
                  ? ''
                  : row.cancellationCharge != ''
                    ? row.cancellationCharge + `% ${t('Charges')}`
                    : `0% ${t('Charges')}`}

              </span>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Vendor Policy')}</label>),
        cell: (row: any) => (
          <>
            {
              row.bookingId &&
              <button
                className='btn text-primary text-decoration-underline fw-bold text-hover-primary'
                onClick={() => {
                  if (row.primaryLanguage == 'English') {
                    setCancellationPolicyInfo(row.en_cancelpolicy)
                  } else if (row.primaryLanguage == 'Russian') {
                    setCancellationPolicyInfo(row.ru_cancelpolicy)
                  } else if (row.primaryLanguage == 'Uzbek') {
                    setCancellationPolicyInfo(row.uz_cancelpolicy)
                  }
                  handleShowInfo();
                }}
              >
                {(row.en_cancelpolicy != '' || row.ru_cancelpolicy != '' || row.uz_cancelpolicy != '') ? `${t('Cancellation Policy')}` : ''}
              </button>
            }
          </>
        ),
        sortable: false,
        filter: true,
        width: '250px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Guest Name')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.guestName ? row.guestName : ''}</label>
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'guestName',
        filter: true,
        width: '250px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Space Name')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{getTranslatedValue(lang, row, '_actionName') || '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        sortField: 'actionName',
        filter: true,
        width: '222px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Space Type')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{getTranslatedValue(lang, row, '_actiontypeName')}</label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '250px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Renting Date')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.checkInFormated ? row.checkInFormated : ''}</div>
          </div>
        ),
        sortable: true,
        sortField: 'checkInFormated',
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Cancellation Date')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.cancellationDateFormated ? row.cancellationDateFormated : ''}</div>
          </div>
        ),
        sortable: true,
        sortField: 'cancellationDateFormated',
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Days before check in')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.dayBeforeCheckIn ? row.dayBeforeCheckIn : ''}</div>
          </div>
        ),
        sortable: true,
        sortField: 'dayBeforeCheckIn',
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Cancellation Charge')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.cancellationCharge == 'LastRecord' ? '' : row.cancellationCharge != ''
                ? row.cancellationCharge + '%'
                : '0%'}
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'cancellationCharge',
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Customer Refund')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.cancellationCharge == 'LastRecord' ? '' : row.customerRefundFormated != '' ? row.customerRefundFormated + '%' : '0%'}</div>
          </div>
        ),
        sortable: true,
        sortField: 'customerRefundFormated',
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Total Paid')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.cancellationCharge == 'LastRecord' ? '' : row.totalAmountFormated != '' ? formatNumber(parseFloat(row.totalAmountFormated)) + ' UZS' : '0 UZS'}</label>
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'totalAmountFormated',
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Refund Amount')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.cancellationCharge == 'LastRecord' ? '' : row.refundAmountFormated != '' ? formatNumber(parseFloat(row.refundAmountFormated)) + ' UZS' : '0 UZS'}</label>
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'refundAmountFormated',
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Final Amount')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.finalAmountFormated ? formatNumber(row.finalAmountFormated) + ' UZS' : '0 UZS'}</label>
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'finalAmountFormated',
        filter: true,
        width: '200px',
      },
      {
        name: (<label className='fw-bold fs-6 text-muted'>{t('Insayr Service Fee')}</label>),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='d-flex align-items-center justify-content-center'>
              <label className='fs-6 fw-bold'>{row.insayrRevenueFormated ? formatNumber(row.insayrRevenueFormated) + ' UZS' : '0 UZS'}</label>
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'insayrRevenueFormated',
        filter: true,
        width: '200px',
      },
    ],
    [t]
  )
  useEffect(() => {
    cancellationBookingListApiCall()
  }, [limit, offset, sortColumn, sortDirection, searchTerm, yearSelectedOptions, yearTypeSelectedOptions, selectedMonth])

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('Cancelled Bookings')}</PageTitle>
      {
        <div className="card card-flush py-4">
          <div className="card-body pt-0">
            <DataTable
              columns={column}
              data={cancellationBookingList}
              pagination
              paginationServer={true}
              onChangePage={handlePageChange}
              paginationTotalRows={totalRecords}
              paginationPerPage={limit}
              onChangeRowsPerPage={handleRowsPerPageChange}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
              subHeader={true}
              subHeaderComponent={
                <CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />
              }
              onSort={handleSort}
              sortServer
            />
          </div>
        </div>
      }

      <Modal
        show={showInfo}
        onHide={handleCloseInfo}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal fade show" id="kt_modal_upload" tabIndex={-1} style={{ display: "block" }} aria-modal="true" role="dialog">
          {/* <!--begin::Modal dialog--> */}
          <div className="modal-dialog modal-dialog-centered mw-700px">
            {/* <!--begin::Modal content--> */}
            <div className="modal-content">
              {/* <!--begin::Form--> */}
              <div className="form" id="kt_modal_upload_form">
                {/* <!--begin::Modal header--> */}
                <div className="modal-header d-flex justify-content-between border-bottom border-1 border-success">
                  {/* <!--begin::Modal title--> */}
                  <h2 className="fw-bold">{t('Cancellation Policy')}</h2>
                  {/* <!--end::Modal title--> */}
                  {/* <!--begin::Close--> */}
                  <div className="btn btn-icon btn-sm btn-active-icon-primary" onClick={handleCloseInfo}>
                    <i className="ki-duotone ki-cross fs-1"><span className="path1"></span><span className="path2"></span></i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>
                {/* <!--end::Modal header--> */}
                {/* <!--begin::Modal body--> */}
                <div className="modal-body pt-10 pb-15 px-lg-17">
                  <div className="row">
                    {
                      cancellationPolicyInfo &&
                      <div dangerouslySetInnerHTML={{ __html: cancellationPolicyInfo }}></div>
                    }
                    {
                      !cancellationPolicyInfo &&
                      <label className='form-label text-muted text-center'>{t('No Policy Found')}</label>
                    }
                  </div>
                </div>
                {/* <!--end::Modal body--> */}
              </div>
              {/* <!--end::Form--> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export { ViewSpaceCancelledBooking }
